
export function ContactHero() {
  return (
    <section className="bg-gradient-to-r from-[#f4fbf7] to-white py-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-brand-primary mb-6">Entre em Contato</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Estou aqui para ajudar você em sua jornada de transformação. Entre em contato e vamos conversar!
          </p>
        </div>
      </div>
    </section>
  );
}
